import { VolumeOff } from '@mui/icons-material';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { useRoyalFanfare } from './useRoyalFanfare';
import styles from './KingEffects.module.css';

/**
 * Fires the royal fanfare on arrival at the king's profile.
 *
 * Renders nothing while silent. Once audio is actually playing it shows a small mute control —
 * sound that starts on its own with no way to stop it is hostile, especially for anyone browsing
 * at work. The control disappears again the moment the fanfare ends.
 */
const KingFanfare = () => {
    const { t } = useTranslation('pages');
    const { playing, stop, unavailable } = useRoyalFanfare();

    if (!playing || unavailable) return null;

    // Portalled to <body> for the same reason as CrownRain: this renders inside the player card,
    // which sets `backdrop-filter` and therefore becomes the containing block for `position: fixed`
    // — leaving the button pinned to the card (on top of the social icons) instead of the viewport.
    return createPortal(
        <button
            type="button"
            className={styles.muteButton}
            onClick={stop}
            aria-label={t('king.stopFanfare')}
            title={t('king.stopFanfare')}
        >
            <VolumeOff sx={{ fontSize: 16 }} />
            {t('king.stopFanfare')}
        </button>,
        document.body
    );
};

export default KingFanfare;
